import React from "react";
import { renderRoutes } from "react-router-config";
import { Redirect } from "react-router-dom";
import MainComponent from "./main";
import Layout from "@/app/core/layouts/main";
import Storage from "@/app/core/util/Storage";

const ProjectShell = props =>  (
  <Layout {...props}>{renderRoutes(props.route.routes, props)}</Layout>
);

const Redirecter = () => <Redirect to="/whats" />;

export const EmpresaRouter = {
  path: "/empresa/:key",
  component: ProjectShell,
  routes: [
    {
      path: "/empresa/:key",
      exact: true,
      component: MainComponent
    },
    {
      path: "*",
      component: Redirecter
    }
  ]
};
